import { AxiosResponse } from 'axios';

import axios from './core';

export default {
  getQuackData: (): Promise<AxiosResponse<any>> => axios.get('rates/'),
};
